FeatureToggleService.$inject = ["featureToggles", "dealerService"];
import "core-js/modules/es6.string.includes.js";
import "core-js/modules/es7.array.includes.js";
import "core-js/modules/es6.array.slice.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.function.name.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.array.from.js";
import "core-js/modules/es6.string.iterator.js";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/web.dom.iterable.js";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import angular from 'angular';
import opportunities from '../core/opportunities.module';
angular.module(opportunities).factory('featureToggleService', FeatureToggleService);
function FeatureToggleService(featureToggles, dealerService) {
  "ngInject";

  return {
    customerEngagementWidget: customerEngagementWidget,
    useFakeCustomerEngagementData: useFakeCustomerEngagementData
  };
  function customerEngagementWidget() {
    return calculateFeatureToggle(featureToggles.enableCustomerEngagementWidget);
  }
  function useFakeCustomerEngagementData() {
    return calculateFeatureToggle(featureToggles.useFakeCustomerEngagementData);
  }
  function calculateFeatureToggle(feature) {
    // falsy means the feature is off
    if (!feature) return false;

    // Literal 'true' means the feature is on for all dealers
    if (feature === true) return true;

    // If it's an array, it is a list of dealer IDs that should have the
    // feature enabled.
    if (Array.isArray(feature)) {
      var selectedDealers = dealerService.getSelectedDealerIds() || [];
      var _iterator = _createForOfIteratorHelper(selectedDealers),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var selectedDealerId = _step.value;
          if (feature.includes(selectedDealerId)) {
            return true;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
    return false;
  }
}